import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const quickActions = [
  {
    name: 'Media Upload',
    icon: '⬆️',
    to: '/media',
    color: 'bg-primary-600',
    adminOnly: false,
  },
  {
    name: 'Add Show',
    icon: '➕',
    to: '/shows',
    color: 'bg-secondary-600',
    roles: ['admin', 'operator'],
  },
  {
    name: 'New Playlist',
    icon: '📜',
    to: '/playlists',
    color: 'bg-warning-600',
    roles: ['admin', 'operator', 'dj', 'editor'],
  },
  {
    name: 'Upload Episode',
    icon: '🎬',
    to: '/episodes',
    color: 'bg-purple-600',
    roles: ['admin', 'operator', 'dj'],
  },
  {
    name: 'Schedule Break',
    icon: '⏰',
    to: '/advertising/breaks',
    color: 'bg-error-600',
    adminOnly: false,
  },
];

export default function QuickActions() {
  const { user } = useAuth();

  const visibleActions = quickActions.filter((action) => {
    if (action.roles && user) {
      return action.roles.includes(user.role);
    }
    return true;
  });

  return (
    <div className="rounded-xl bg-dark-850 border border-dark-700 p-4 shadow-xl">
      <h3 className="mb-2 text-base font-semibold text-dark-100">Quick Actions</h3>
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-5">
        {visibleActions.map((action) => (
          <Link
            key={action.name}
            to={action.to}
            className={`flex items-center justify-center gap-1.5 rounded-lg ${action.color} px-2 py-2 text-center text-white transition-transform hover:scale-105`}
          >
            <span className="text-base">{action.icon}</span>
            <span className="text-xs font-medium truncate">{action.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
